import { render } from "./vendor-popup.vue?vue&type=template&id=7fc5a960"
import script from "./vendor-popup.vue?vue&type=script&lang=js"
export * from "./vendor-popup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__